import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=45773e42&"
import script from "./Header.vue?vue&type=script&lang=ts&"
export * from "./Header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QSpace,QItem,QItemSection,QItemLabel,ClosePopup} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QSpace,QItem,QItemSection,QItemLabel}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
